import { z } from 'zod'
import { FirestoreTimestamp } from './utils'

// MaintenanceProgram Collection (companies/{companyId}/sites/{siteId}/units/{unitId}/maintenancePrograms/{programId})
export const MaintenanceProgram = z.object({
  surveyId: z.string().nullable(),
  companyId: z.string(),
  siteId: z.string(),
  unitId: z.string(),
  startDateMonth: z.number(),
  startDateYear: z.number(),

  // Status flags
  isCurrent: z.boolean().default(true),

  // Per-task cadence in months, keyed by itemId. Single source of truth for
  // interval — replaces the per-row `interval` field that previously lived
  // on every MaintenanceProgramItem occurrence.
  tasksInterval: z.record(z.string(), z.number()).default({}),

  // Audit fields
  createdAt: FirestoreTimestamp,
  updatedAt: FirestoreTimestamp,
})

// MaintenanceProgramItem Collection (companies/{companyId}/sites/{siteId}/units/{unitId}/maintenancePrograms/{programId}/items/{itemId})
export const MaintenanceProgramItem = z.object({
  maintenanceProgramItemId: z.string(),
  maintenanceProgramId: z.string(),
  itemId: z.string(),

  // Denormalized hierarchy fields for queries
  companyId: z.string(),
  siteId: z.string(),
  unitId: z.string(),

  // Due date-based scheduling (NEW)
  // Stored as ISO date string (YYYY-MM-DD) representing the beginning of the month
  // This represents when the maintenance is due within the month
  dueDate: z.iso.date(),
  status: z.enum(['pending', 'completed', 'overdue']).default('pending'),
  completedDate: FirestoreTimestamp.nullable(),
  completedBy: z.string().nullable(),

  // Time tracking
  minutes: z.number().default(0),
  yearlyMinutes: z.number().default(0),
  minutesTwo: z.number().default(0),
  yearlyMinutesTwo: z.number().default(0),

  // References
  refUnitId: z.string().optional(),

  // Audit fields
  createdAt: FirestoreTimestamp,
  updatedAt: FirestoreTimestamp,

  // Denormalized for offline access
  codeRef: z.string().nullable(),
  task: z.string(),
  maintOrTest: z.string().optional(),
  typeOfItem: z.string().optional(),
})

export type MaintenanceProgram = z.infer<typeof MaintenanceProgram>
export type MaintenanceProgramItem = z.infer<typeof MaintenanceProgramItem>
